import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WINDOW } from '~core/services/window/window.service';
import { AppState } from '~core/states/app/app.state';
import { NetworkState } from '~offline/states/network-state/network.state';

import { CheckForUpdateService } from '../service-worker/check-for-update/check-for-update.service';
import {
  HandleUnrecoverableStateService
} from '../service-worker/handle-unrecoverable-state/handle-unrecoverable-state.service';
import { LogUpdateService } from '../service-worker/log-update/log-update.service';
import { PromptUpdateService } from '../service-worker/prompt-update/prompt-update.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineService {
  private window = inject<Window>(WINDOW);
  private networkState = inject(NetworkState);
  private checkForUpdateSvc = inject(CheckForUpdateService);
  private logUpdateSvc = inject(LogUpdateService);
  private promptUpdateSvc = inject(PromptUpdateService);
  private handleUnrecoverableStateSvc = inject(HandleUnrecoverableStateService);


  private appState = inject(AppState);
  private http = inject(HttpClient);

  async init() {
    this.networkState.set('networkOnline', (window?.navigator?.onLine));
    this.window.addEventListener('online', () => this.networkState.set('networkOnline', true));
    this.window.addEventListener('offline', () => this.networkState.set('networkOnline', false));
  }
}

export function initializeOfflineService() {
  inject(OfflineService).init();
}
